import { type FC, useEffect } from "react";

import { useGetSavedFiltersQuery } from "~/feature/savedFilters/savedFiltersApi";
import { useSubscriptionGuard } from "~/feature/subscription/components/SubscriptionGuard/useSubscriptionGuard";
import { useSavedFilters } from "~/providers/SavedFiltersProvider";
import { useAppUser } from "~/providers/UserProvider";
import { FeatureKey } from "~/types/subscription";
import { handleError } from "~/utils/handleError";

export const InitSavedFilters: FC = () => {
  const { syncLoading } = useAppUser();
  const { isLocked } = useSubscriptionGuard(FeatureKey.SAVE_FILTER);
  const { data, isLoading, error, isFetching } = useGetSavedFiltersQuery(
    {
      limit: 100,
      page: 1,
    },
    { skip: isLocked || syncLoading }
  );
  const { setSavedFilters, setIsLoading, setIsFetching } = useSavedFilters();

  useEffect(() => {
    if (data) {
      setSavedFilters(data?.data);
    }
  }, [data, setSavedFilters]);

  useEffect(() => {
    setIsLoading(isLoading);
  }, [setIsLoading, isLoading]);

  useEffect(() => {
    setIsFetching(isFetching);
  }, [setIsFetching, isFetching]);

  useEffect(() => {
    if (error) {
      handleError(error);
    }
  }, [error]);

  return null;
};
